module.exports = "../../app/cells/components/subproduct_landings/header_cell.rb";